module.exports = __webpack_public_path__ + "img/AI.77d1e09f.svg";